module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/sightseeing@3x_70a1fb.jpg";